import {
  addDummyColumns,
  surgeryDummyColumn,
} from '@common/components/table/SurgeryGridHelpers';
import {
  VisitAnesthesiaFormSurgeryVitalModel,
  IVisitAnesthesiaFormSurgeryVitalModel,
  IModel,
  Model,
  ModelRecord,
} from '@common/models';
import { DateTime } from 'luxon';

export interface IVisitAnesthesiaFormSurgeryModel extends IModel {
  visitAnesthesiaFormSurgeryId: number;
  anesthesiaStartTime: string;
  anesthesiaStopTime: string;
  surgeryStartTime: string;
  surgeryStopTime: string;
  complicationNotes: string;
  vitals: IVisitAnesthesiaFormSurgeryVitalModel[];
  dateCreated: string;
  dateUpdated: string;
  userUpdatedTitle: string;
  userUpdatedFirstName: string;
  userUpdatedLastName: string;
}

export class VisitAnesthesiaFormSurgeryModel
  extends Model
  implements ModelRecord<IVisitAnesthesiaFormSurgeryModel>
{
  visitAnesthesiaFormSurgeryId: number;
  anesthesiaStartTime: string;
  anesthesiaStopTime: string;
  surgeryStartTime: string;
  surgeryStopTime: string;
  complicationNotes: string;
  vitals: VisitAnesthesiaFormSurgeryVitalModel[] = [];
  dateCreated: DateTime;
  dateUpdated: DateTime;
  userUpdatedTitle: string;
  userUpdatedFirstName: string;
  userUpdatedLastName: string;
  vitalsLength: number;

  constructor(params?: Partial<IVisitAnesthesiaFormSurgeryModel>) {
    super(params);
    this.visitAnesthesiaFormSurgeryId = _.defaultTo(
      params?.visitAnesthesiaFormSurgeryId,
      0,
    );
    this.anesthesiaStartTime = _.defaultTo(params?.anesthesiaStartTime, '');
    this.anesthesiaStopTime = _.defaultTo(params?.anesthesiaStopTime, '');
    this.surgeryStartTime = _.defaultTo(params?.surgeryStartTime, '');
    this.surgeryStopTime = _.defaultTo(params?.surgeryStopTime, '');
    this.complicationNotes = _.defaultTo(params?.complicationNotes, '');
    this.vitalsLength = params?.vitals?.length || 0;
    _.map(params?.vitals, (m) => {
      this.vitals.push(new VisitAnesthesiaFormSurgeryVitalModel(m));
    });
    this.vitals = [
      ...addDummyColumns(this.vitals.length, surgeryDummyColumn),
      ...this.vitals,
    ];

    if (!this.anesthesiaStopTime && this.vitalsLength >= 25) {
      this.vitals.push(surgeryDummyColumn(this.vitalsLength + 1));
    }
    this.vitals.sort((a, b) => Number(a.interval) - Number(b.interval));
    this.dateCreated = params?.dateCreated
      ? DateTime.fromISO(params.dateCreated, { zone: 'utc' })
      : DateTime.now();
    this.dateUpdated = params?.dateUpdated
      ? DateTime.fromISO(params.dateUpdated, { zone: 'utc' })
      : DateTime.now();
    this.userUpdatedTitle = _.defaultTo(params?.userUpdatedTitle, '');
    this.userUpdatedFirstName = _.defaultTo(params?.userUpdatedFirstName, '');
    this.userUpdatedLastName = _.defaultTo(params?.userUpdatedLastName, '');
  }
}
